import { inputAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";
import { colors } from "../tokens/colors";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(inputAnatomy.keys);

const baseStyle = definePartsStyle({
  field: {
    fontSize: "1rem",
    borderRadius: "1rem",
  },
});

const success = definePartsStyle(() => {
  return {
    field: {
      background: "transparent",
      border: "1px solid transparent",
      borderColor: colors.neutral[800],
      _placeholder: {
        color: "foreground",
      },
      _focus: {
        boxShadow: colors.shadow.success,
        border: "1px solid",
        borderColor: colors.success[500],
        zIndex: 1, // Ensure the focused input is above others
      },
      _hover: {},
      _invalid: {},
    },
  };
});

const warning = definePartsStyle(() => {
  return {
    field: {
      background: "transparent",
      _placeholder: {
        color: "foreground",
      },
      _focus: {
        border: "1px solid",
        borderColor: "yellow.500",
        zIndex: 1, // Ensure the focused input is above others
      },
      _hover: {},
      _invalid: {},
    },
  };
});

const error = definePartsStyle(() => {
  return {
    field: {
      _focus: {
        boxShadow: colors.shadow.error,
        border: "1px solid",
        borderColor: "red.500",
        zIndex: 1, // Ensure the focused input is above others
      },
      _hover: {},
      _invalid: {},
    },
  };
});

const inputTheme = defineMultiStyleConfig({
  baseStyle,
  variants: { success, warning, error },
});

export default inputTheme;
